import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ClientInsuranceProviderStore, ClientInsuranceProviderState } from './client-insurance-provider.store';

@Injectable({ providedIn: 'root' })
export class ClientInsuranceProviderQuery extends QueryEntity<ClientInsuranceProviderState> {

  constructor(protected store: ClientInsuranceProviderStore) {
    super(store);
  }

}
